// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"48835d67","348":"38af3e09","361":"b943e715","541":"7e546ea2","723":"ed5918e6","862":"aa449a81","961":"ec880c2c"}[chunkId] + ".chunk.js";
};